import axios from 'axios'
import session from 'vue-cookies'
const BASE_URL_V2 =  'https://api.bertiebets.com/v2/horses'
var key = session.get('bertiebets.admin.key')
export async function getHorse(name, raceType) {
  console.log("LOading horse")
  var response = await axios.get(`${BASE_URL_V2}/${name}?type=${raceType}`, {headers:{'x-api-key' : key}})
  if (response.status === 200) {
    console.log(response.data)
    return response.data
  }else {
    console.log(response)
  }
}
